import { agroApi } from "../../../../redux/api/api";
import { IPesticidesResponse, IPesticidesParams } from "./types";
import { Paths } from "../../../../paths";

export const PesticidesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getPesticidesListt: builder.query<IPesticidesResponse, IPesticidesParams>({
      query: ({ year, territorialUnitId }) => ({
        // url: "/departments/chemicalization/pesticide-register/analytical-data",
        url: `${Paths.chemicalization.pesticideRegister}/analytical-data`,
        method: "GET",
        params: {
          ...(year && { year }),
          territorialUnitId
        }
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPesticidesListtQuery } = PesticidesApi;